module.exports = __webpack_public_path__ + "img/loader.d6ff6cdb.gif";